export default __webpack_public_path__ + "static/media/NeoNX110_LateralIzq.6b1b70c8.webp";